import React from "react";
import {connect} from "react-redux";
import { Switch, Route } from "react-router-dom";

import IbList from 'views/ContractDetailsReport/IbContractDetails'
import AdminList from 'views/ContractDetailsReport/AdminContractDetails'

class ContractDetailsReport extends React.Component {
  render() {
    let component = window.location.href.includes('/ib/') ? IbList : AdminList
    return (
          <Switch>
            <Route component={component}/>
          </Switch>
    );
  }
}
const state=(state)=>({})
const dispatch=(dispatch)=>({})
export default connect(state,dispatch)(ContractDetailsReport);



// WEBPACK FOOTER //
// ./src/views/ContractDetailsReport/ContractDetailsReport.jsx